<template>
  <div class="exam-guide-view">
    <div class="exam-guide-view__top">
      <bread-crumbs />
      <div class="exam-guide-view__side">
        <!-- <div class="export">
          <DownloadExams />
        </div> -->

        <div class="calculator">
          <Calculator />
        </div>
      </div>
    </div>

    <exam-search />
    <featured-exams />
  </div>
</template>

<script>
import BreadCrumbs from './components/BreadCrumbs.vue'
import ExamSearch from './components/ExamSearch.vue'
import FeaturedExams from './components/FeaturedExams.vue'
import Calculator from './components/ExamCalculator/Calculator.vue'
import DownloadExams from './components/DownloadExams.vue'

export default {
  name: 'ExamGuideView',
  components: {
    BreadCrumbs,
    ExamSearch,
    FeaturedExams,
    Calculator,
    DownloadExams
  }
}
</script>

<style lang="scss">
.exam-guide-view {
  background-color: #f7f7f7;
  padding-bottom: 35px;
  position: relative;

  & > .exam-search,
  & > .featured-exams {
    position: relative;
    z-index: 2;
  }

  &:before {
    content: '';
    display: block;
    width: 372px;
    height: 455px;
    background-image: url('/static/images/site/bg-search1.svg');
    background-repeat: no-repeat;
    background-size: contain;
    top: 70px;
    left: 0;
    position: absolute;
    z-index: 1;
  }
  &:after {
    content: url('/static/images/site/decoration-lab-glass2.svg');
    display: block;
    width: 292px;
    height: 632px;
    background-image: url('/static/images/site/bg-search2.svg');
    background-repeat: no-repeat;
    background-size: contain;
    top: 20px;
    right: 0;
    display: flex;
    align-items: flex-end;
    position: absolute;
    z-index: 1;
  }

  &__top {
    display: flex;
    justify-content: space-between;
    min-height: 110px;
    padding-right: 70px;
  }

  &__side {
    z-index: 9;
    margin-top: 24px;

    .export {
      margin-bottom: 8px;
    }
  }
}
</style>
